import { ReactElement } from 'react';

/**
 * Integration Page.
 * @returns - A Integration Page Component.
 */
export default function Integration(): ReactElement {
  return (
    <div className="bg-container-500 rounded flex flex-1 justify-center items-center text-6xl font-bold text-white my-4">
      Coming soon
    </div>
  );
}
